/**
 * Maximum dimension (width or height) for photos, in pixels.
 *
 * Photos are downsized (if needed) while maintaining their aspect ratio.
 * @constant {number}
 */
export const PHOTO_MAX_DIMENSION = 2048

/**
 * JPEG compression quality for photos, between 0 and 1.
 *
 * @constant {number}
 */
export const JPEG_QUALITY = 0.85
